export default __webpack_public_path__ + "static/media/pool-vehicle-res-btn.cf13489a.svg";